import React from 'react';
import { Accordion } from '@mantine/core';

import DivisionCard from './DivisionCard';
import { OpsDivision } from '../../codegen/graphql';
import Header from './DivisionsHeader';

type Props = Readonly<{
    divisions: OpsDivision[];
}>;

function Divisions({ divisions }: Props) {
    return (
        <>
            <Header />
            <Accordion
                multiple
                classNames={{
                    control: 'flex shadow-md mt-2 h-[64px] bg-white p-0',
                    content: 'px-0',
                    item: 'border-none',
                    chevron: 'absolute right-[1.5%]',
                    label: 'p-0 w-full',
                }}
            >
                {divisions.map(division => (
                    <DivisionCard key={division.id} division={division} />
                ))}
            </Accordion>
        </>
    );
}

export default Divisions;
